import {post} from "./request";

export const reviewApi = {};
reviewApi.add = async ({body}) => {
  try {
    const {data} = await post(`/review/create`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
